export default __webpack_public_path__ + "static/media/icon-ledger.849c209b.svg";